// Locale codes. Mirrors the backend App\Localisation\Locales.
//
// One representation everywhere: the internal code with an underscore (es_MX) —
// backend, translation-catalogue folders, stored values, the API, and the
// public URL path (/es_MX/...). The single exception is BCP-47 language tags
// (<html lang>, hreflang), which require a hyphen — see htmlLang().

export const SUPPORTED_LOCALES = ["en", "es_MX"] as const

export type Locale = (typeof SUPPORTED_LOCALES)[number]

export const FALLBACK_LOCALE: Locale = "en"

export const isLocale = (value: string): value is Locale =>
  (SUPPORTED_LOCALES as readonly string[]).includes(value)

// Internal code → BCP-47 tag for the <html lang> / hreflang attributes (the
// only place a locale is rewritten; underscores are not valid BCP-47).
const BCP47: Record<Locale, string> = { en: "en", es_MX: "es-MX" }

export const htmlLang = (locale: Locale): string => BCP47[locale]
